import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'

// Import translation files
import authEN from './locales/en/auth.json'
import commonEN from './locales/en/common.json'
import authIT from './locales/it/auth.json'
import commonIT from './locales/it/common.json'

export const defaultNS = 'common'
export const resources = {
  en: {
    common: commonEN,
    auth: authEN
  },
  it: {
    common: commonIT,
    auth: authIT
  }
} as const

i18n.use(initReactI18next).init({
  resources,
  defaultNS,
  lng: 'it', // Default language, will be overridden by Next.js locale
  fallbackLng: 'it',
  supportedLngs: ['it', 'en', 'es', 'fr', 'de', 'pt'],
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: false
  }
})

export default i18n
